import { default as editpB7TdgpzlYMeta } from "/app/apps/valet/src/pages/[storeSlug]/customizations/claim-portal/edit.vue?macro=true";
import { default as indexjIUgvw2UiBMeta } from "/app/apps/valet/src/pages/[storeSlug]/customizations/claim-portal/index.vue?macro=true";
import { default as editj8VXSGVHCsMeta } from "/app/apps/valet/src/pages/[storeSlug]/customizations/emails/edit.vue?macro=true";
import { default as index39jJJWaV1nMeta } from "/app/apps/valet/src/pages/[storeSlug]/customizations/emails/index.vue?macro=true";
import { default as _91id_93Y7PbeVuTbXMeta } from "/app/apps/valet/src/pages/[storeSlug]/customizations/info-modals/edit/[id].vue?macro=true";
import { default as indexXdsTeAVQatMeta } from "/app/apps/valet/src/pages/[storeSlug]/customizations/info-modals/index.vue?macro=true";
import { default as _91id_93OXYxpbFwVjMeta } from "/app/apps/valet/src/pages/[storeSlug]/customizations/widgets/edit/[id].vue?macro=true";
import { default as indexSazynqQMliMeta } from "/app/apps/valet/src/pages/[storeSlug]/customizations/widgets/index.vue?macro=true";
import { default as indexWQn7ruwB1yMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/admin/index.vue?macro=true";
import { default as indexumaGVZqTiVMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/admin/partner-payouts/index.vue?macro=true";
import { default as indexGE9pUoQMbmMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/admin/payments/index.vue?macro=true";
import { default as indexS32Kk59F5JMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/admin/payouts/index.vue?macro=true";
import { default as admineGD1YPzaqnMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/admin.vue?macro=true";
import { default as indexkSmHfam21MMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payments/index.vue?macro=true";
import { default as indexBMpKcFzCb4Meta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/index.vue?macro=true";
import { default as billsJX9pN68oadMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/bills.vue?macro=true";
import { default as discountsuphXHiQCDoMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/discounts.vue?macro=true";
import { default as prior_45monthsDJj45rQhTnMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/prior-months.vue?macro=true";
import { default as resolutionsTkDvxz5r5PMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/resolutions.vue?macro=true";
import { default as revenue_45shareFYO6q6MZfhMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/revenue-share.vue?macro=true";
import { default as _91id_93M0vbwyLhidMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id].vue?macro=true";
import { default as indexJ8SsB8MubTMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payments/manage-by-store/index.vue?macro=true";
import { default as indexpQtIgbPhJAMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payments/payment-methods/index.vue?macro=true";
import { default as paymentsS9ur97XOAeMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payments.vue?macro=true";
import { default as correctionson4IZtmgsDMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/corrections.vue?macro=true";
import { default as discountsExFfA6loNwMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/discounts.vue?macro=true";
import { default as not_45reimbursedMLOZrPhFt0Meta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/not-reimbursed.vue?macro=true";
import { default as prior_45monthsoMEAmbPepBMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/prior-months.vue?macro=true";
import { default as reimbursed40fj5TakUBMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/reimbursed.vue?macro=true";
import { default as revenue_45shareS5kvmCgl2iMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/revenue-share.vue?macro=true";
import { default as _91id_93beWOErWA97Meta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id].vue?macro=true";
import { default as indexMA9HNU16R1Meta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payouts/index.vue?macro=true";
import { default as payoutsSwFAsoV4RUMeta } from "/app/apps/valet/src/pages/[storeSlug]/finance/payouts.vue?macro=true";
import { default as _91folder_93aHoFzqMW1jMeta } from "/app/apps/valet/src/pages/[storeSlug]/macros/[status]/[folder].vue?macro=true";
import { default as indexSGLidQC8NsMeta } from "/app/apps/valet/src/pages/[storeSlug]/macros/index.vue?macro=true";
import { default as _91appId_93yv2X8eWvkWMeta } from "/app/apps/valet/src/pages/[storeSlug]/marketplace/[appId].vue?macro=true";
import { default as _91installationId_93lodfLDSNxRMeta } from "/app/apps/valet/src/pages/[storeSlug]/marketplace/apps/[installationId].vue?macro=true";
import { default as browseoQvWsOMHwUMeta } from "/app/apps/valet/src/pages/[storeSlug]/marketplace/browse.vue?macro=true";
import { default as indexoas6a6hJ23Meta } from "/app/apps/valet/src/pages/[storeSlug]/marketplace/index.vue?macro=true";
import { default as installed99nPgDjLcQMeta } from "/app/apps/valet/src/pages/[storeSlug]/marketplace/installed.vue?macro=true";
import { default as privateeLQLZvNTZIMeta } from "/app/apps/valet/src/pages/[storeSlug]/marketplace/private.vue?macro=true";
import { default as marketplaceJQBcXb1GU6Meta } from "/app/apps/valet/src/pages/[storeSlug]/marketplace.vue?macro=true";
import { default as payouts3RowdJUel8Meta } from "/app/apps/valet/src/pages/[storeSlug]/payouts.vue?macro=true";
import { default as indexOKAkOqprxFMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/api-tokens/index.vue?macro=true";
import { default as automationtsiQskHSEuMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/automation.vue?macro=true";
import { default as capabilities6elwUcUVH1Meta } from "/app/apps/valet/src/pages/[storeSlug]/settings/capabilities.vue?macro=true";
import { default as claimsYVeNJsJeIJMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/claims.vue?macro=true";
import { default as collaboratorsDM89Jxpvb1Meta } from "/app/apps/valet/src/pages/[storeSlug]/settings/collaborators.vue?macro=true";
import { default as contactidseHktUwXMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/contact.vue?macro=true";
import { default as contractsysOC9hGW6dMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/contracts.vue?macro=true";
import { default as developer96JH7ZNnqcMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/developer.vue?macro=true";
import { default as generalSp40W9bVxnMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/general.vue?macro=true";
import { default as indexoMenywjPRtMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/index.vue?macro=true";
import { default as policiesml2RGYu0VsMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/policies.vue?macro=true";
import { default as indexfK3QwIK3ZbMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/sops/index.vue?macro=true";
import { default as warrantyHJeAYT3FITMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/warranty.vue?macro=true";
import { default as indexZP6Fg67eCiMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/webhooks/index.vue?macro=true";
import { default as _91id_93BAJ6N2HXZCMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings/webhooks/view/[id].vue?macro=true";
import { default as settingsdUtcbkhyqbMeta } from "/app/apps/valet/src/pages/[storeSlug]/settings.vue?macro=true";
import { default as _91id_93UL07pkkKt6Meta } from "/app/apps/valet/src/pages/[storeSlug]/sops/[id].vue?macro=true";
import { default as activeOgYMwPAQERMeta } from "/app/apps/valet/src/pages/[storeSlug]/team-members/active.vue?macro=true";
import { default as inactives0DaWaotoiMeta } from "/app/apps/valet/src/pages/[storeSlug]/team-members/inactive.vue?macro=true";
import { default as indexp3VH6SBtTbMeta } from "/app/apps/valet/src/pages/[storeSlug]/team-members/index.vue?macro=true";
import { default as _91id_93tWyPfbwuejMeta } from "/app/apps/valet/src/pages/[storeSlug]/team-members/member/[id].vue?macro=true";
import { default as team_45membersFXgPCUloKyMeta } from "/app/apps/valet/src/pages/[storeSlug]/team-members.vue?macro=true";
import { default as indexrmTXRnSL9vMeta } from "/app/apps/valet/src/pages/[storeSlug]/tests/index.vue?macro=true";
import { default as _91id_93v0mAsEDtOuMeta } from "/app/apps/valet/src/pages/[storeSlug]/tests/view/[id].vue?macro=true";
import { default as brands8u8rcLDwt2Meta } from "/app/apps/valet/src/pages/account-admin/brands.vue?macro=true";
import { default as child_45accountssxjUyDYVNKMeta } from "/app/apps/valet/src/pages/account-admin/child-accounts.vue?macro=true";
import { default as indexLyFeb9oFQVMeta } from "/app/apps/valet/src/pages/account-admin/index.vue?macro=true";
import { default as payoutseV3NmwwoyBMeta } from "/app/apps/valet/src/pages/account-admin/payouts.vue?macro=true";
import { default as settingsgDSz4oJlywMeta } from "/app/apps/valet/src/pages/account-admin/settings.vue?macro=true";
import { default as team_45membersxG233w7hfLMeta } from "/app/apps/valet/src/pages/account-admin/team-members.vue?macro=true";
import { default as userscMlXxpJqpPMeta } from "/app/apps/valet/src/pages/account-admin/users.vue?macro=true";
import { default as account_45adminsIqOJTqGCsMeta } from "/app/apps/valet/src/pages/account-admin.vue?macro=true";
import { default as account6We7F7pLGLMeta } from "/app/apps/valet/src/pages/account.vue?macro=true";
import { default as app_45reviewbKZOSZkgAWMeta } from "/app/apps/valet/src/pages/admin/app-review.vue?macro=true";
import { default as ai_45modelsmKmJDQyJGeMeta } from "/app/apps/valet/src/pages/admin/claim-automation/ai-models.vue?macro=true";
import { default as ai_45spendNNoL1Qdz9FMeta } from "/app/apps/valet/src/pages/admin/claim-automation/ai-spend.vue?macro=true";
import { default as control_45panelZzzXbKYnlKMeta } from "/app/apps/valet/src/pages/admin/claim-automation/control-panel.vue?macro=true";
import { default as feedbackdAHTtr1xbzMeta } from "/app/apps/valet/src/pages/admin/claim-automation/feedback.vue?macro=true";
import { default as _91id_93lRvmBG9jKcMeta } from "/app/apps/valet/src/pages/admin/claim-automation/history/[claimId]/automations/[id].vue?macro=true";
import { default as indexrFOolTk2v8Meta } from "/app/apps/valet/src/pages/admin/claim-automation/history/[claimId]/index.vue?macro=true";
import { default as indexSuaz3DWiqsMeta } from "/app/apps/valet/src/pages/admin/claim-automation/history/index.vue?macro=true";
import { default as index9BuosJMOGDMeta } from "/app/apps/valet/src/pages/admin/claim-automation/insights/index.vue?macro=true";
import { default as _91model_9395FimKkDqRMeta } from "/app/apps/valet/src/pages/admin/claim-automation/models/[model].vue?macro=true";
import { default as indexaG6er63EahMeta } from "/app/apps/valet/src/pages/admin/claim-automation/models/index.vue?macro=true";
import { default as index5nrgGRQv8HMeta } from "/app/apps/valet/src/pages/admin/claim-automation/patterns/index.vue?macro=true";
import { default as indexWdVese0SCYMeta } from "/app/apps/valet/src/pages/admin/claim-automation/post-claim/index.vue?macro=true";
import { default as patternsEP8JipVL3SMeta } from "/app/apps/valet/src/pages/admin/claim-automation/post-claim/patterns.vue?macro=true";
import { default as sentimentCK0cd0IGjlMeta } from "/app/apps/valet/src/pages/admin/claim-automation/post-claim/sentiment.vue?macro=true";
import { default as post_45claimphGKzzcnV5Meta } from "/app/apps/valet/src/pages/admin/claim-automation/post-claim.vue?macro=true";
import { default as sentimentzgxv9Wb4sKMeta } from "/app/apps/valet/src/pages/admin/claim-automation/sentiment.vue?macro=true";
import { default as storesPXaUUM1UxQMeta } from "/app/apps/valet/src/pages/admin/claim-automation/stores.vue?macro=true";
import { default as indexSMJ5HErSxaMeta } from "/app/apps/valet/src/pages/admin/engineering/index.vue?macro=true";
import { default as index1TTyeGOtVRMeta } from "/app/apps/valet/src/pages/admin/engineering/jobs/index.vue?macro=true";
import { default as _91id_93HHaWN7WjnaMeta } from "/app/apps/valet/src/pages/admin/engineering/queues/[id].vue?macro=true";
import { default as indexjJqYpkykDsMeta } from "/app/apps/valet/src/pages/admin/engineering/queues/index.vue?macro=true";
import { default as engineeringAVa1S3l3s1Meta } from "/app/apps/valet/src/pages/admin/engineering.vue?macro=true";
import { default as _91status_93WzQFBaY0N9Meta } from "/app/apps/valet/src/pages/admin/global-macros/[status].vue?macro=true";
import { default as indexzTUzRi8Sp0Meta } from "/app/apps/valet/src/pages/admin/global-macros/index.vue?macro=true";
import { default as _91id_936pgR4OX7bBMeta } from "/app/apps/valet/src/pages/admin/implementation/brands/[id].vue?macro=true";
import { default as index2Hx49y9bozMeta } from "/app/apps/valet/src/pages/admin/implementation/brands/index.vue?macro=true";
import { default as _91id_93Q9sJ6FmjWHMeta } from "/app/apps/valet/src/pages/admin/implementation/deployments/[id].vue?macro=true";
import { default as indexnLnoUXfrtNMeta } from "/app/apps/valet/src/pages/admin/implementation/deployments/index.vue?macro=true";
import { default as op_45productGUG2JldMEWMeta } from "/app/apps/valet/src/pages/admin/implementation/op-product.vue?macro=true";
import { default as implementationdVXrQFAknMMeta } from "/app/apps/valet/src/pages/admin/implementation.vue?macro=true";
import { default as macros5xNrJ4ubn3Meta } from "/app/apps/valet/src/pages/admin/macros.vue?macro=true";
import { default as personal_45access_45tokensKlY4xeImx7Meta } from "/app/apps/valet/src/pages/admin/personal-access-tokens.vue?macro=true";
import { default as slack_45botW5px3MJrKdMeta } from "/app/apps/valet/src/pages/admin/slack-bot.vue?macro=true";
import { default as activeELNvCcCPS6Meta } from "/app/apps/valet/src/pages/admin/stores/active.vue?macro=true";
import { default as devKsrs6wAcCtMeta } from "/app/apps/valet/src/pages/admin/stores/dev.vue?macro=true";
import { default as inactiveElFGYe5W0yMeta } from "/app/apps/valet/src/pages/admin/stores/inactive.vue?macro=true";
import { default as index1puAZh9BPMMeta } from "/app/apps/valet/src/pages/admin/stores/index.vue?macro=true";
import { default as onboardingUyCXevX9UvMeta } from "/app/apps/valet/src/pages/admin/stores/onboarding.vue?macro=true";
import { default as storesc0wtJ2ZaVTMeta } from "/app/apps/valet/src/pages/admin/stores.vue?macro=true";
import { default as themesn7IfSdNrR1Meta } from "/app/apps/valet/src/pages/admin/themes.vue?macro=true";
import { default as _91type_93lMwbHYaisRMeta } from "/app/apps/valet/src/pages/admin/users/[type].vue?macro=true";
import { default as indexAPdr0f8YIhMeta } from "/app/apps/valet/src/pages/admin/users/index.vue?macro=true";
import { default as _91id_93m8uzBMhMeOMeta } from "/app/apps/valet/src/pages/admin/users/user/[id].vue?macro=true";
import { default as usersL3in0c9UwPMeta } from "/app/apps/valet/src/pages/admin/users.vue?macro=true";
import { default as indexgMTz97nFbiMeta } from "/app/apps/valet/src/pages/admin/whitelabel/index.vue?macro=true";
import { default as whitelabelEBWbHVoBXUMeta } from "/app/apps/valet/src/pages/admin/whitelabel.vue?macro=true";
import { default as account_45dashboard6HusnTJ4RCMeta } from "/app/apps/valet/src/pages/analytics/account-dashboard.vue?macro=true";
import { default as apiQLRCQo7eJBMeta } from "/app/apps/valet/src/pages/analytics/api.vue?macro=true";
import { default as child_45account_45dashboardbUUghgUqX2Meta } from "/app/apps/valet/src/pages/analytics/child-account-dashboard.vue?macro=true";
import { default as revenue_45calculatorkBmbo5pLGkMeta } from "/app/apps/valet/src/pages/analytics/revenue-calculator.vue?macro=true";
import { default as _91type_93Q5WUEoRL9TMeta } from "/app/apps/valet/src/pages/claims/[type].vue?macro=true";
import { default as indexHkXFeGch4QMeta } from "/app/apps/valet/src/pages/claims/index.vue?macro=true";
import { default as _91id_93O8cZFWuSc6Meta } from "/app/apps/valet/src/pages/claims/view/[id].vue?macro=true";
import { default as claimsP2G3Mels63Meta } from "/app/apps/valet/src/pages/claims.vue?macro=true";
import { default as _91customerId_93eH1d8iGoi1Meta } from "/app/apps/valet/src/pages/customers/[customerId].vue?macro=true";
import { default as indexcGvFK6yQLZMeta } from "/app/apps/valet/src/pages/customers/index.vue?macro=true";
import { default as indexM07iimR40CMeta } from "/app/apps/valet/src/pages/dashboard/index.vue?macro=true";
import { default as overviewpixbpEFc94Meta } from "/app/apps/valet/src/pages/dashboard/overview.vue?macro=true";
import { default as dashboardLo4QSk7jTkMeta } from "/app/apps/valet/src/pages/dashboard.vue?macro=true";
import { default as editj8HpAFD93NMeta } from "/app/apps/valet/src/pages/developer/apps/[appId]/edit.vue?macro=true";
import { default as indexHt2Zq0D96dMeta } from "/app/apps/valet/src/pages/developer/apps/[appId]/index.vue?macro=true";
import { default as installationsfUjIoVxuCAMeta } from "/app/apps/valet/src/pages/developer/apps/[appId]/installations.vue?macro=true";
import { default as submissionkItyqoNEL9Meta } from "/app/apps/valet/src/pages/developer/apps/[appId]/submission.vue?macro=true";
import { default as _91appId_93NR2akGmVH4Meta } from "/app/apps/valet/src/pages/developer/apps/[appId].vue?macro=true";
import { default as indexQr9udfKw3zMeta } from "/app/apps/valet/src/pages/developer/apps/index.vue?macro=true";
import { default as indexyfPZyn3Y1GMeta } from "/app/apps/valet/src/pages/developer/collaborations/index.vue?macro=true";
import { default as index8dVnShfs5SMeta } from "/app/apps/valet/src/pages/developer/index.vue?macro=true";
import { default as organization4scD05QjZzMeta } from "/app/apps/valet/src/pages/developer/organization.vue?macro=true";
import { default as signupsxCZR4XNbNMeta } from "/app/apps/valet/src/pages/developer/signup.vue?macro=true";
import { default as developerHdYkS8ExoqMeta } from "/app/apps/valet/src/pages/developer.vue?macro=true";
import { default as _91type_93OneFdSFkfWMeta } from "/app/apps/valet/src/pages/gallery/[type].vue?macro=true";
import { default as index9b1wYVE4IJMeta } from "/app/apps/valet/src/pages/gallery/index.vue?macro=true";
import { default as hidden_45by_45account_45admindzntt12PK0Meta } from "/app/apps/valet/src/pages/hidden-by-account-admin.vue?macro=true";
import { default as indexstNItgaC36Meta } from "/app/apps/valet/src/pages/index.vue?macro=true";
import { default as activelGm53ex5aBMeta } from "/app/apps/valet/src/pages/integrations/active.vue?macro=true";
import { default as availablecYaX6EG6fNMeta } from "/app/apps/valet/src/pages/integrations/available.vue?macro=true";
import { default as integrationsiJWd7lFOGlMeta } from "/app/apps/valet/src/pages/integrations.vue?macro=true";
import { default as callbackHquhJgOurbMeta } from "/app/apps/valet/src/pages/login/callback.vue?macro=true";
import { default as indexzxcf67RnbkMeta } from "/app/apps/valet/src/pages/login/index.vue?macro=true";
import { default as emailKX2LJ14Q4oMeta } from "/app/apps/valet/src/pages/login/mfa/email.vue?macro=true";
import { default as index0rad0U3Z0RMeta } from "/app/apps/valet/src/pages/login/mfa/index.vue?macro=true";
import { default as otp7Pa2DIyeqcMeta } from "/app/apps/valet/src/pages/login/mfa/otp.vue?macro=true";
import { default as not_45foundpZXsfmGS2rMeta } from "/app/apps/valet/src/pages/login/not-found.vue?macro=true";
import { default as resete0ME7RAFInMeta } from "/app/apps/valet/src/pages/login/reset.vue?macro=true";
import { default as set_45passworde06Vh6way0Meta } from "/app/apps/valet/src/pages/login/set-password.vue?macro=true";
import { default as welcomexUye6lIWzWMeta } from "/app/apps/valet/src/pages/login/welcome.vue?macro=true";
import { default as loginXuUDFXbT8eMeta } from "/app/apps/valet/src/pages/login.vue?macro=true";
import { default as indexzYZYZFfsOfMeta } from "/app/apps/valet/src/pages/orders/index.vue?macro=true";
import { default as personal_45access_45tokensZ0LY1N1LYtMeta } from "/app/apps/valet/src/pages/personal-access-tokens.vue?macro=true";
import { default as indexcglEOpfOWXMeta } from "/app/apps/valet/src/pages/products/index.vue?macro=true";
import { default as indexSIm4NSmpgGMeta } from "/app/apps/valet/src/pages/returns/index.vue?macro=true";
import { default as returnsHDhAWHctVlMeta } from "/app/apps/valet/src/pages/returns.vue?macro=true";
import { default as index8CKNUgKc6bMeta } from "/app/apps/valet/src/pages/reviews/index.vue?macro=true";
import { default as _91type_93gZjL9lKqnOMeta } from "/app/apps/valet/src/pages/store-credit/[type].vue?macro=true";
import { default as index4PvaHPyIn9Meta } from "/app/apps/valet/src/pages/store-credit/index.vue?macro=true";
import { default as store_45creditMDe6yHOjqUMeta } from "/app/apps/valet/src/pages/store-credit.vue?macro=true";
import { default as reinstall_45complete1cMWZGjIi2Meta } from "/app/apps/valet/src/pages/store/reinstall-complete.vue?macro=true";
import { default as reinstallajdv8WQf0lMeta } from "/app/apps/valet/src/pages/store/reinstall.vue?macro=true";
import { default as unauthorizedImIOFdzRSwMeta } from "/app/apps/valet/src/pages/unauthorized.vue?macro=true";
import { default as _91type_93ksACqwc3lnMeta } from "/app/apps/valet/src/pages/warranties/[type].vue?macro=true";
import { default as indexgJkUrSXUweMeta } from "/app/apps/valet/src/pages/warranties/index.vue?macro=true";
export default [
  {
    name: "storeSlug-customizations-claim-portal-edit___en",
    path: "/:storeSlug()/customizations/claim-portal/edit",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/claim-portal/edit.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-claim-portal-edit___fr",
    path: "/fr/:storeSlug()/customizations/claim-portal/edit",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/claim-portal/edit.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-claim-portal-edit___es",
    path: "/es/:storeSlug()/customizations/claim-portal/edit",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/claim-portal/edit.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-claim-portal___en",
    path: "/:storeSlug()/customizations/claim-portal",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/claim-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-claim-portal___fr",
    path: "/fr/:storeSlug()/customizations/claim-portal",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/claim-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-claim-portal___es",
    path: "/es/:storeSlug()/customizations/claim-portal",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/claim-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-emails-edit___en",
    path: "/:storeSlug()/customizations/emails/edit",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/emails/edit.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-emails-edit___fr",
    path: "/fr/:storeSlug()/customizations/emails/edit",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/emails/edit.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-emails-edit___es",
    path: "/es/:storeSlug()/customizations/emails/edit",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/emails/edit.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-emails___en",
    path: "/:storeSlug()/customizations/emails",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/emails/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-emails___fr",
    path: "/fr/:storeSlug()/customizations/emails",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/emails/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-emails___es",
    path: "/es/:storeSlug()/customizations/emails",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/emails/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-info-modals-edit-id___en",
    path: "/:storeSlug()/customizations/info-modals/edit/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/info-modals/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-info-modals-edit-id___fr",
    path: "/fr/:storeSlug()/customizations/info-modals/edit/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/info-modals/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-info-modals-edit-id___es",
    path: "/es/:storeSlug()/customizations/info-modals/edit/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/info-modals/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-info-modals___en",
    path: "/:storeSlug()/customizations/info-modals",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/info-modals/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-info-modals___fr",
    path: "/fr/:storeSlug()/customizations/info-modals",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/info-modals/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-info-modals___es",
    path: "/es/:storeSlug()/customizations/info-modals",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/info-modals/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-widgets-edit-id___en",
    path: "/:storeSlug()/customizations/widgets/edit/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/widgets/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-widgets-edit-id___fr",
    path: "/fr/:storeSlug()/customizations/widgets/edit/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/widgets/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-widgets-edit-id___es",
    path: "/es/:storeSlug()/customizations/widgets/edit/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/widgets/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-widgets___en",
    path: "/:storeSlug()/customizations/widgets",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/widgets/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-widgets___fr",
    path: "/fr/:storeSlug()/customizations/widgets",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/widgets/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-customizations-widgets___es",
    path: "/es/:storeSlug()/customizations/widgets",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/customizations/widgets/index.vue").then(m => m.default || m)
  },
  {
    name: admineGD1YPzaqnMeta?.name,
    path: "/:storeSlug()/finance/admin",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-admin___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-admin-partner-payouts___en",
    path: "partner-payouts",
    meta: indexumaGVZqTiVMeta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/partner-payouts/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-admin-payments___en",
    path: "payments",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-admin-payouts___en",
    path: "payouts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/payouts/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: admineGD1YPzaqnMeta?.name,
    path: "/fr/:storeSlug()/finance/admin",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-admin___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-admin-partner-payouts___fr",
    path: "partner-payouts",
    meta: indexumaGVZqTiVMeta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/partner-payouts/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-admin-payments___fr",
    path: "payments",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-admin-payouts___fr",
    path: "payouts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/payouts/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: admineGD1YPzaqnMeta?.name,
    path: "/es/:storeSlug()/finance/admin",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-admin___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-admin-partner-payouts___es",
    path: "partner-payouts",
    meta: indexumaGVZqTiVMeta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/partner-payouts/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-admin-payments___es",
    path: "payments",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-admin-payouts___es",
    path: "payouts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/admin/payouts/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: paymentsS9ur97XOAeMeta?.name,
    path: "/:storeSlug()/finance/payments",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payments___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices___en",
    path: "invoices",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id___en",
    path: "invoices/view/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payments-invoices-view-id-bills___en",
    path: "bills",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/bills.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-discounts___en",
    path: "discounts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/discounts.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-prior-months___en",
    path: "prior-months",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/prior-months.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-resolutions___en",
    path: "resolutions",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/resolutions.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-revenue-share___en",
    path: "revenue-share",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/revenue-share.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "storeSlug-finance-payments-manage-by-store___en",
    path: "manage-by-store",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/manage-by-store/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-payment-methods___en",
    path: "payment-methods",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/payment-methods/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: paymentsS9ur97XOAeMeta?.name,
    path: "/fr/:storeSlug()/finance/payments",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payments___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices___fr",
    path: "invoices",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id___fr",
    path: "invoices/view/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payments-invoices-view-id-bills___fr",
    path: "bills",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/bills.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-discounts___fr",
    path: "discounts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/discounts.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-prior-months___fr",
    path: "prior-months",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/prior-months.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-resolutions___fr",
    path: "resolutions",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/resolutions.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-revenue-share___fr",
    path: "revenue-share",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/revenue-share.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "storeSlug-finance-payments-manage-by-store___fr",
    path: "manage-by-store",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/manage-by-store/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-payment-methods___fr",
    path: "payment-methods",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/payment-methods/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: paymentsS9ur97XOAeMeta?.name,
    path: "/es/:storeSlug()/finance/payments",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payments___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices___es",
    path: "invoices",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id___es",
    path: "invoices/view/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payments-invoices-view-id-bills___es",
    path: "bills",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/bills.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-discounts___es",
    path: "discounts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/discounts.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-prior-months___es",
    path: "prior-months",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/prior-months.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-resolutions___es",
    path: "resolutions",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/resolutions.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-invoices-view-id-revenue-share___es",
    path: "revenue-share",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/invoices/view/[id]/revenue-share.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "storeSlug-finance-payments-manage-by-store___es",
    path: "manage-by-store",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/manage-by-store/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payments-payment-methods___es",
    path: "payment-methods",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payments/payment-methods/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: payoutsSwFAsoV4RUMeta?.name,
    path: "/:storeSlug()/finance/payouts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payouts-id___en",
    path: ":id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payouts-id-corrections___en",
    path: "corrections",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/corrections.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-discounts___en",
    path: "discounts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/discounts.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-not-reimbursed___en",
    path: "not-reimbursed",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/not-reimbursed.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-prior-months___en",
    path: "prior-months",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/prior-months.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-reimbursed___en",
    path: "reimbursed",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/reimbursed.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-revenue-share___en",
    path: "revenue-share",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/revenue-share.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "storeSlug-finance-payouts___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: payoutsSwFAsoV4RUMeta?.name,
    path: "/fr/:storeSlug()/finance/payouts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payouts-id___fr",
    path: ":id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payouts-id-corrections___fr",
    path: "corrections",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/corrections.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-discounts___fr",
    path: "discounts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/discounts.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-not-reimbursed___fr",
    path: "not-reimbursed",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/not-reimbursed.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-prior-months___fr",
    path: "prior-months",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/prior-months.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-reimbursed___fr",
    path: "reimbursed",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/reimbursed.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-revenue-share___fr",
    path: "revenue-share",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/revenue-share.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "storeSlug-finance-payouts___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: payoutsSwFAsoV4RUMeta?.name,
    path: "/es/:storeSlug()/finance/payouts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payouts-id___es",
    path: ":id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-finance-payouts-id-corrections___es",
    path: "corrections",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/corrections.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-discounts___es",
    path: "discounts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/discounts.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-not-reimbursed___es",
    path: "not-reimbursed",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/not-reimbursed.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-prior-months___es",
    path: "prior-months",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/prior-months.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-reimbursed___es",
    path: "reimbursed",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/reimbursed.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-finance-payouts-id-revenue-share___es",
    path: "revenue-share",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/[id]/revenue-share.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "storeSlug-finance-payouts___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/finance/payouts/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "storeSlug-macros-status-folder___en",
    path: "/:storeSlug()/macros/:status()/:folder()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/macros/[status]/[folder].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-macros-status-folder___fr",
    path: "/fr/:storeSlug()/macros/:status()/:folder()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/macros/[status]/[folder].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-macros-status-folder___es",
    path: "/es/:storeSlug()/macros/:status()/:folder()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/macros/[status]/[folder].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-macros___en",
    path: "/:storeSlug()/macros",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/macros/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-macros___fr",
    path: "/fr/:storeSlug()/macros",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/macros/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-macros___es",
    path: "/es/:storeSlug()/macros",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/macros/index.vue").then(m => m.default || m)
  },
  {
    name: marketplaceJQBcXb1GU6Meta?.name,
    path: "/:storeSlug()/marketplace",
    meta: marketplaceJQBcXb1GU6Meta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-marketplace-appId___en",
    path: ":appId()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/[appId].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-apps-installationId___en",
    path: "apps/:installationId()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/apps/[installationId].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-browse___en",
    path: "browse",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/browse.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-installed___en",
    path: "installed",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/installed.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-private___en",
    path: "private",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/private.vue").then(m => m.default || m)
  }
]
  },
  {
    name: marketplaceJQBcXb1GU6Meta?.name,
    path: "/fr/:storeSlug()/marketplace",
    meta: marketplaceJQBcXb1GU6Meta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-marketplace-appId___fr",
    path: ":appId()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/[appId].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-apps-installationId___fr",
    path: "apps/:installationId()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/apps/[installationId].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-browse___fr",
    path: "browse",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/browse.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-installed___fr",
    path: "installed",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/installed.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-private___fr",
    path: "private",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/private.vue").then(m => m.default || m)
  }
]
  },
  {
    name: marketplaceJQBcXb1GU6Meta?.name,
    path: "/es/:storeSlug()/marketplace",
    meta: marketplaceJQBcXb1GU6Meta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-marketplace-appId___es",
    path: ":appId()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/[appId].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-apps-installationId___es",
    path: "apps/:installationId()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/apps/[installationId].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-browse___es",
    path: "browse",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/browse.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-installed___es",
    path: "installed",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/installed.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-marketplace-private___es",
    path: "private",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/marketplace/private.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "storeSlug-payouts___en",
    path: "/:storeSlug()/payouts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/payouts.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-payouts___fr",
    path: "/fr/:storeSlug()/payouts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/payouts.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-payouts___es",
    path: "/es/:storeSlug()/payouts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/payouts.vue").then(m => m.default || m)
  },
  {
    name: settingsdUtcbkhyqbMeta?.name,
    path: "/:storeSlug()/settings",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-settings-api-tokens___en",
    path: "api-tokens",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/api-tokens/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-automation___en",
    path: "automation",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/automation.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-capabilities___en",
    path: "capabilities",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/capabilities.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-claims___en",
    path: "claims",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/claims.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-collaborators___en",
    path: "collaborators",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/collaborators.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-contact___en",
    path: "contact",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/contact.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-contracts___en",
    path: "contracts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/contracts.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-developer___en",
    path: "developer",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/developer.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-general___en",
    path: "general",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/general.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-policies___en",
    path: "policies",
    meta: policiesml2RGYu0VsMeta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/policies.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-sops___en",
    path: "sops",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/sops/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-warranty___en",
    path: "warranty",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/warranty.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-webhooks___en",
    path: "webhooks",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/webhooks/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-webhooks-view-id___en",
    path: "webhooks/view/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/webhooks/view/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: settingsdUtcbkhyqbMeta?.name,
    path: "/fr/:storeSlug()/settings",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-settings-api-tokens___fr",
    path: "api-tokens",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/api-tokens/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-automation___fr",
    path: "automation",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/automation.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-capabilities___fr",
    path: "capabilities",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/capabilities.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-claims___fr",
    path: "claims",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/claims.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-collaborators___fr",
    path: "collaborators",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/collaborators.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-contact___fr",
    path: "contact",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/contact.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-contracts___fr",
    path: "contracts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/contracts.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-developer___fr",
    path: "developer",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/developer.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-general___fr",
    path: "general",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/general.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-policies___fr",
    path: "policies",
    meta: policiesml2RGYu0VsMeta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/policies.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-sops___fr",
    path: "sops",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/sops/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-warranty___fr",
    path: "warranty",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/warranty.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-webhooks___fr",
    path: "webhooks",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/webhooks/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-webhooks-view-id___fr",
    path: "webhooks/view/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/webhooks/view/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: settingsdUtcbkhyqbMeta?.name,
    path: "/es/:storeSlug()/settings",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-settings-api-tokens___es",
    path: "api-tokens",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/api-tokens/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-automation___es",
    path: "automation",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/automation.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-capabilities___es",
    path: "capabilities",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/capabilities.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-claims___es",
    path: "claims",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/claims.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-collaborators___es",
    path: "collaborators",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/collaborators.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-contact___es",
    path: "contact",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/contact.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-contracts___es",
    path: "contracts",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/contracts.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-developer___es",
    path: "developer",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/developer.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-general___es",
    path: "general",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/general.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-policies___es",
    path: "policies",
    meta: policiesml2RGYu0VsMeta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/policies.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-sops___es",
    path: "sops",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/sops/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-warranty___es",
    path: "warranty",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/warranty.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-webhooks___es",
    path: "webhooks",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/webhooks/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-settings-webhooks-view-id___es",
    path: "webhooks/view/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/settings/webhooks/view/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "storeSlug-sops-id___en",
    path: "/:storeSlug()/sops/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/sops/[id].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-sops-id___fr",
    path: "/fr/:storeSlug()/sops/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/sops/[id].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-sops-id___es",
    path: "/es/:storeSlug()/sops/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/sops/[id].vue").then(m => m.default || m)
  },
  {
    name: team_45membersFXgPCUloKyMeta?.name,
    path: "/:storeSlug()/team-members",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-team-members-active___en",
    path: "active",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/active.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-team-members-inactive___en",
    path: "inactive",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/inactive.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-team-members___en",
    path: "",
    meta: indexp3VH6SBtTbMeta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-team-members-member-id___en",
    path: "member/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/member/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: team_45membersFXgPCUloKyMeta?.name,
    path: "/fr/:storeSlug()/team-members",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-team-members-active___fr",
    path: "active",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/active.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-team-members-inactive___fr",
    path: "inactive",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/inactive.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-team-members___fr",
    path: "",
    meta: indexp3VH6SBtTbMeta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-team-members-member-id___fr",
    path: "member/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/member/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: team_45membersFXgPCUloKyMeta?.name,
    path: "/es/:storeSlug()/team-members",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members.vue").then(m => m.default || m),
    children: [
  {
    name: "storeSlug-team-members-active___es",
    path: "active",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/active.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-team-members-inactive___es",
    path: "inactive",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/inactive.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-team-members___es",
    path: "",
    meta: indexp3VH6SBtTbMeta || {},
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-team-members-member-id___es",
    path: "member/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/team-members/member/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "storeSlug-tests___en",
    path: "/:storeSlug()/tests",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/tests/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-tests___fr",
    path: "/fr/:storeSlug()/tests",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/tests/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-tests___es",
    path: "/es/:storeSlug()/tests",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/tests/index.vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-tests-view-id___en",
    path: "/:storeSlug()/tests/view/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/tests/view/[id].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-tests-view-id___fr",
    path: "/fr/:storeSlug()/tests/view/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/tests/view/[id].vue").then(m => m.default || m)
  },
  {
    name: "storeSlug-tests-view-id___es",
    path: "/es/:storeSlug()/tests/view/:id()",
    component: () => import("/app/apps/valet/src/pages/[storeSlug]/tests/view/[id].vue").then(m => m.default || m)
  },
  {
    name: account_45adminsIqOJTqGCsMeta?.name,
    path: "/account-admin",
    meta: account_45adminsIqOJTqGCsMeta || {},
    component: () => import("/app/apps/valet/src/pages/account-admin.vue").then(m => m.default || m),
    children: [
  {
    name: "account-admin-brands___en",
    path: "brands",
    component: () => import("/app/apps/valet/src/pages/account-admin/brands.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-child-accounts___en",
    path: "child-accounts",
    component: () => import("/app/apps/valet/src/pages/account-admin/child-accounts.vue").then(m => m.default || m)
  },
  {
    name: "account-admin___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/account-admin/index.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-payouts___en",
    path: "payouts",
    component: () => import("/app/apps/valet/src/pages/account-admin/payouts.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-settings___en",
    path: "settings",
    component: () => import("/app/apps/valet/src/pages/account-admin/settings.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-team-members___en",
    path: "team-members",
    component: () => import("/app/apps/valet/src/pages/account-admin/team-members.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-users___en",
    path: "users",
    component: () => import("/app/apps/valet/src/pages/account-admin/users.vue").then(m => m.default || m)
  }
]
  },
  {
    name: account_45adminsIqOJTqGCsMeta?.name,
    path: "/fr/account-admin",
    meta: account_45adminsIqOJTqGCsMeta || {},
    component: () => import("/app/apps/valet/src/pages/account-admin.vue").then(m => m.default || m),
    children: [
  {
    name: "account-admin-brands___fr",
    path: "brands",
    component: () => import("/app/apps/valet/src/pages/account-admin/brands.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-child-accounts___fr",
    path: "child-accounts",
    component: () => import("/app/apps/valet/src/pages/account-admin/child-accounts.vue").then(m => m.default || m)
  },
  {
    name: "account-admin___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/account-admin/index.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-payouts___fr",
    path: "payouts",
    component: () => import("/app/apps/valet/src/pages/account-admin/payouts.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-settings___fr",
    path: "settings",
    component: () => import("/app/apps/valet/src/pages/account-admin/settings.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-team-members___fr",
    path: "team-members",
    component: () => import("/app/apps/valet/src/pages/account-admin/team-members.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-users___fr",
    path: "users",
    component: () => import("/app/apps/valet/src/pages/account-admin/users.vue").then(m => m.default || m)
  }
]
  },
  {
    name: account_45adminsIqOJTqGCsMeta?.name,
    path: "/es/account-admin",
    meta: account_45adminsIqOJTqGCsMeta || {},
    component: () => import("/app/apps/valet/src/pages/account-admin.vue").then(m => m.default || m),
    children: [
  {
    name: "account-admin-brands___es",
    path: "brands",
    component: () => import("/app/apps/valet/src/pages/account-admin/brands.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-child-accounts___es",
    path: "child-accounts",
    component: () => import("/app/apps/valet/src/pages/account-admin/child-accounts.vue").then(m => m.default || m)
  },
  {
    name: "account-admin___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/account-admin/index.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-payouts___es",
    path: "payouts",
    component: () => import("/app/apps/valet/src/pages/account-admin/payouts.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-settings___es",
    path: "settings",
    component: () => import("/app/apps/valet/src/pages/account-admin/settings.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-team-members___es",
    path: "team-members",
    component: () => import("/app/apps/valet/src/pages/account-admin/team-members.vue").then(m => m.default || m)
  },
  {
    name: "account-admin-users___es",
    path: "users",
    component: () => import("/app/apps/valet/src/pages/account-admin/users.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account___en",
    path: "/account",
    component: () => import("/app/apps/valet/src/pages/account.vue").then(m => m.default || m)
  },
  {
    name: "account___fr",
    path: "/fr/account",
    component: () => import("/app/apps/valet/src/pages/account.vue").then(m => m.default || m)
  },
  {
    name: "account___es",
    path: "/es/account",
    component: () => import("/app/apps/valet/src/pages/account.vue").then(m => m.default || m)
  },
  {
    name: "admin-app-review___en",
    path: "/admin/app-review",
    component: () => import("/app/apps/valet/src/pages/admin/app-review.vue").then(m => m.default || m)
  },
  {
    name: "admin-app-review___fr",
    path: "/fr/admin/app-review",
    component: () => import("/app/apps/valet/src/pages/admin/app-review.vue").then(m => m.default || m)
  },
  {
    name: "admin-app-review___es",
    path: "/es/admin/app-review",
    component: () => import("/app/apps/valet/src/pages/admin/app-review.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-ai-models___en",
    path: "/admin/claim-automation/ai-models",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/ai-models.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-ai-models___fr",
    path: "/fr/admin/claim-automation/ai-models",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/ai-models.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-ai-models___es",
    path: "/es/admin/claim-automation/ai-models",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/ai-models.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-ai-spend___en",
    path: "/admin/claim-automation/ai-spend",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/ai-spend.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-ai-spend___fr",
    path: "/fr/admin/claim-automation/ai-spend",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/ai-spend.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-ai-spend___es",
    path: "/es/admin/claim-automation/ai-spend",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/ai-spend.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-control-panel___en",
    path: "/admin/claim-automation/control-panel",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/control-panel.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-control-panel___fr",
    path: "/fr/admin/claim-automation/control-panel",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/control-panel.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-control-panel___es",
    path: "/es/admin/claim-automation/control-panel",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/control-panel.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-feedback___en",
    path: "/admin/claim-automation/feedback",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/feedback.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-feedback___fr",
    path: "/fr/admin/claim-automation/feedback",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/feedback.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-feedback___es",
    path: "/es/admin/claim-automation/feedback",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/feedback.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-history-claimId-automations-id___en",
    path: "/admin/claim-automation/history/:claimId()/automations/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/history/[claimId]/automations/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-history-claimId-automations-id___fr",
    path: "/fr/admin/claim-automation/history/:claimId()/automations/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/history/[claimId]/automations/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-history-claimId-automations-id___es",
    path: "/es/admin/claim-automation/history/:claimId()/automations/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/history/[claimId]/automations/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-history-claimId___en",
    path: "/admin/claim-automation/history/:claimId()",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/history/[claimId]/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-history-claimId___fr",
    path: "/fr/admin/claim-automation/history/:claimId()",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/history/[claimId]/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-history-claimId___es",
    path: "/es/admin/claim-automation/history/:claimId()",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/history/[claimId]/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-history___en",
    path: "/admin/claim-automation/history",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/history/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-history___fr",
    path: "/fr/admin/claim-automation/history",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/history/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-history___es",
    path: "/es/admin/claim-automation/history",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/history/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-insights___en",
    path: "/admin/claim-automation/insights",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/insights/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-insights___fr",
    path: "/fr/admin/claim-automation/insights",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/insights/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-insights___es",
    path: "/es/admin/claim-automation/insights",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/insights/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-models-model___en",
    path: "/admin/claim-automation/models/:model()",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/models/[model].vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-models-model___fr",
    path: "/fr/admin/claim-automation/models/:model()",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/models/[model].vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-models-model___es",
    path: "/es/admin/claim-automation/models/:model()",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/models/[model].vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-models___en",
    path: "/admin/claim-automation/models",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/models/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-models___fr",
    path: "/fr/admin/claim-automation/models",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/models/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-models___es",
    path: "/es/admin/claim-automation/models",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/models/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-patterns___en",
    path: "/admin/claim-automation/patterns",
    redirect: index5nrgGRQv8HMeta?.redirect,
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/patterns/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-patterns___fr",
    path: "/fr/admin/claim-automation/patterns",
    redirect: index5nrgGRQv8HMeta?.redirect,
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/patterns/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-patterns___es",
    path: "/es/admin/claim-automation/patterns",
    redirect: index5nrgGRQv8HMeta?.redirect,
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/patterns/index.vue").then(m => m.default || m)
  },
  {
    name: post_45claimphGKzzcnV5Meta?.name,
    path: "/admin/claim-automation/post-claim",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-claim-automation-post-claim___en",
    path: "",
    redirect: indexWdVese0SCYMeta?.redirect,
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-post-claim-patterns___en",
    path: "patterns",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim/patterns.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-post-claim-sentiment___en",
    path: "sentiment",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim/sentiment.vue").then(m => m.default || m)
  }
]
  },
  {
    name: post_45claimphGKzzcnV5Meta?.name,
    path: "/fr/admin/claim-automation/post-claim",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-claim-automation-post-claim___fr",
    path: "",
    redirect: indexWdVese0SCYMeta?.redirect,
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-post-claim-patterns___fr",
    path: "patterns",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim/patterns.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-post-claim-sentiment___fr",
    path: "sentiment",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim/sentiment.vue").then(m => m.default || m)
  }
]
  },
  {
    name: post_45claimphGKzzcnV5Meta?.name,
    path: "/es/admin/claim-automation/post-claim",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-claim-automation-post-claim___es",
    path: "",
    redirect: indexWdVese0SCYMeta?.redirect,
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-post-claim-patterns___es",
    path: "patterns",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim/patterns.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-post-claim-sentiment___es",
    path: "sentiment",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/post-claim/sentiment.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "admin-claim-automation-sentiment___en",
    path: "/admin/claim-automation/sentiment",
    redirect: sentimentzgxv9Wb4sKMeta?.redirect,
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/sentiment.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-sentiment___fr",
    path: "/fr/admin/claim-automation/sentiment",
    redirect: sentimentzgxv9Wb4sKMeta?.redirect,
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/sentiment.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-sentiment___es",
    path: "/es/admin/claim-automation/sentiment",
    redirect: sentimentzgxv9Wb4sKMeta?.redirect,
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/sentiment.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-stores___en",
    path: "/admin/claim-automation/stores",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/stores.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-stores___fr",
    path: "/fr/admin/claim-automation/stores",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/stores.vue").then(m => m.default || m)
  },
  {
    name: "admin-claim-automation-stores___es",
    path: "/es/admin/claim-automation/stores",
    component: () => import("/app/apps/valet/src/pages/admin/claim-automation/stores.vue").then(m => m.default || m)
  },
  {
    name: engineeringAVa1S3l3s1Meta?.name,
    path: "/admin/engineering",
    component: () => import("/app/apps/valet/src/pages/admin/engineering.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-engineering___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-engineering-jobs___en",
    path: "jobs",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-engineering-queues-id___en",
    path: "queues/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/queues/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-engineering-queues___en",
    path: "queues",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/queues/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: engineeringAVa1S3l3s1Meta?.name,
    path: "/fr/admin/engineering",
    component: () => import("/app/apps/valet/src/pages/admin/engineering.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-engineering___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-engineering-jobs___fr",
    path: "jobs",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-engineering-queues-id___fr",
    path: "queues/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/queues/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-engineering-queues___fr",
    path: "queues",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/queues/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: engineeringAVa1S3l3s1Meta?.name,
    path: "/es/admin/engineering",
    component: () => import("/app/apps/valet/src/pages/admin/engineering.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-engineering___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-engineering-jobs___es",
    path: "jobs",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-engineering-queues-id___es",
    path: "queues/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/queues/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-engineering-queues___es",
    path: "queues",
    component: () => import("/app/apps/valet/src/pages/admin/engineering/queues/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "admin-global-macros-status___en",
    path: "/admin/global-macros/:status()",
    component: () => import("/app/apps/valet/src/pages/admin/global-macros/[status].vue").then(m => m.default || m)
  },
  {
    name: "admin-global-macros-status___fr",
    path: "/fr/admin/global-macros/:status()",
    component: () => import("/app/apps/valet/src/pages/admin/global-macros/[status].vue").then(m => m.default || m)
  },
  {
    name: "admin-global-macros-status___es",
    path: "/es/admin/global-macros/:status()",
    component: () => import("/app/apps/valet/src/pages/admin/global-macros/[status].vue").then(m => m.default || m)
  },
  {
    name: "admin-global-macros___en",
    path: "/admin/global-macros",
    component: () => import("/app/apps/valet/src/pages/admin/global-macros/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-global-macros___fr",
    path: "/fr/admin/global-macros",
    component: () => import("/app/apps/valet/src/pages/admin/global-macros/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-global-macros___es",
    path: "/es/admin/global-macros",
    component: () => import("/app/apps/valet/src/pages/admin/global-macros/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation___en",
    path: "/admin/implementation",
    component: () => import("/app/apps/valet/src/pages/admin/implementation.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-implementation-brands-id___en",
    path: "brands/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/brands/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-brands___en",
    path: "brands",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/brands/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-deployments-id___en",
    path: "deployments/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/deployments/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-deployments___en",
    path: "deployments",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/deployments/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-op-product___en",
    path: "op-product",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/op-product.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "admin-implementation___fr",
    path: "/fr/admin/implementation",
    component: () => import("/app/apps/valet/src/pages/admin/implementation.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-implementation-brands-id___fr",
    path: "brands/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/brands/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-brands___fr",
    path: "brands",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/brands/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-deployments-id___fr",
    path: "deployments/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/deployments/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-deployments___fr",
    path: "deployments",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/deployments/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-op-product___fr",
    path: "op-product",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/op-product.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "admin-implementation___es",
    path: "/es/admin/implementation",
    component: () => import("/app/apps/valet/src/pages/admin/implementation.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-implementation-brands-id___es",
    path: "brands/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/brands/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-brands___es",
    path: "brands",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/brands/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-deployments-id___es",
    path: "deployments/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/deployments/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-deployments___es",
    path: "deployments",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/deployments/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-implementation-op-product___es",
    path: "op-product",
    component: () => import("/app/apps/valet/src/pages/admin/implementation/op-product.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "admin-macros___en",
    path: "/admin/macros",
    component: () => import("/app/apps/valet/src/pages/admin/macros.vue").then(m => m.default || m)
  },
  {
    name: "admin-macros___fr",
    path: "/fr/admin/macros",
    component: () => import("/app/apps/valet/src/pages/admin/macros.vue").then(m => m.default || m)
  },
  {
    name: "admin-macros___es",
    path: "/es/admin/macros",
    component: () => import("/app/apps/valet/src/pages/admin/macros.vue").then(m => m.default || m)
  },
  {
    name: "admin-personal-access-tokens___en",
    path: "/admin/personal-access-tokens",
    component: () => import("/app/apps/valet/src/pages/admin/personal-access-tokens.vue").then(m => m.default || m)
  },
  {
    name: "admin-personal-access-tokens___fr",
    path: "/fr/admin/personal-access-tokens",
    component: () => import("/app/apps/valet/src/pages/admin/personal-access-tokens.vue").then(m => m.default || m)
  },
  {
    name: "admin-personal-access-tokens___es",
    path: "/es/admin/personal-access-tokens",
    component: () => import("/app/apps/valet/src/pages/admin/personal-access-tokens.vue").then(m => m.default || m)
  },
  {
    name: "admin-slack-bot___en",
    path: "/admin/slack-bot",
    component: () => import("/app/apps/valet/src/pages/admin/slack-bot.vue").then(m => m.default || m)
  },
  {
    name: "admin-slack-bot___fr",
    path: "/fr/admin/slack-bot",
    component: () => import("/app/apps/valet/src/pages/admin/slack-bot.vue").then(m => m.default || m)
  },
  {
    name: "admin-slack-bot___es",
    path: "/es/admin/slack-bot",
    component: () => import("/app/apps/valet/src/pages/admin/slack-bot.vue").then(m => m.default || m)
  },
  {
    name: storesc0wtJ2ZaVTMeta?.name,
    path: "/admin/stores",
    component: () => import("/app/apps/valet/src/pages/admin/stores.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-stores-active___en",
    path: "active",
    component: () => import("/app/apps/valet/src/pages/admin/stores/active.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores-dev___en",
    path: "dev",
    component: () => import("/app/apps/valet/src/pages/admin/stores/dev.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores-inactive___en",
    path: "inactive",
    component: () => import("/app/apps/valet/src/pages/admin/stores/inactive.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/stores/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores-onboarding___en",
    path: "onboarding",
    component: () => import("/app/apps/valet/src/pages/admin/stores/onboarding.vue").then(m => m.default || m)
  }
]
  },
  {
    name: storesc0wtJ2ZaVTMeta?.name,
    path: "/fr/admin/stores",
    component: () => import("/app/apps/valet/src/pages/admin/stores.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-stores-active___fr",
    path: "active",
    component: () => import("/app/apps/valet/src/pages/admin/stores/active.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores-dev___fr",
    path: "dev",
    component: () => import("/app/apps/valet/src/pages/admin/stores/dev.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores-inactive___fr",
    path: "inactive",
    component: () => import("/app/apps/valet/src/pages/admin/stores/inactive.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/stores/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores-onboarding___fr",
    path: "onboarding",
    component: () => import("/app/apps/valet/src/pages/admin/stores/onboarding.vue").then(m => m.default || m)
  }
]
  },
  {
    name: storesc0wtJ2ZaVTMeta?.name,
    path: "/es/admin/stores",
    component: () => import("/app/apps/valet/src/pages/admin/stores.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-stores-active___es",
    path: "active",
    component: () => import("/app/apps/valet/src/pages/admin/stores/active.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores-dev___es",
    path: "dev",
    component: () => import("/app/apps/valet/src/pages/admin/stores/dev.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores-inactive___es",
    path: "inactive",
    component: () => import("/app/apps/valet/src/pages/admin/stores/inactive.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/stores/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-stores-onboarding___es",
    path: "onboarding",
    component: () => import("/app/apps/valet/src/pages/admin/stores/onboarding.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "admin-themes___en",
    path: "/admin/themes",
    meta: themesn7IfSdNrR1Meta || {},
    component: () => import("/app/apps/valet/src/pages/admin/themes.vue").then(m => m.default || m)
  },
  {
    name: "admin-themes___fr",
    path: "/fr/admin/themes",
    meta: themesn7IfSdNrR1Meta || {},
    component: () => import("/app/apps/valet/src/pages/admin/themes.vue").then(m => m.default || m)
  },
  {
    name: "admin-themes___es",
    path: "/es/admin/themes",
    meta: themesn7IfSdNrR1Meta || {},
    component: () => import("/app/apps/valet/src/pages/admin/themes.vue").then(m => m.default || m)
  },
  {
    name: usersL3in0c9UwPMeta?.name,
    path: "/admin/users",
    component: () => import("/app/apps/valet/src/pages/admin/users.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-users-type___en",
    path: ":type()",
    component: () => import("/app/apps/valet/src/pages/admin/users/[type].vue").then(m => m.default || m)
  },
  {
    name: "admin-users___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/users/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-users-user-id___en",
    path: "user/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/users/user/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: usersL3in0c9UwPMeta?.name,
    path: "/fr/admin/users",
    component: () => import("/app/apps/valet/src/pages/admin/users.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-users-type___fr",
    path: ":type()",
    component: () => import("/app/apps/valet/src/pages/admin/users/[type].vue").then(m => m.default || m)
  },
  {
    name: "admin-users___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/users/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-users-user-id___fr",
    path: "user/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/users/user/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: usersL3in0c9UwPMeta?.name,
    path: "/es/admin/users",
    component: () => import("/app/apps/valet/src/pages/admin/users.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-users-type___es",
    path: ":type()",
    component: () => import("/app/apps/valet/src/pages/admin/users/[type].vue").then(m => m.default || m)
  },
  {
    name: "admin-users___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/users/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-users-user-id___es",
    path: "user/:id()",
    component: () => import("/app/apps/valet/src/pages/admin/users/user/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: whitelabelEBWbHVoBXUMeta?.name,
    path: "/admin/whitelabel",
    component: () => import("/app/apps/valet/src/pages/admin/whitelabel.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-whitelabel___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/whitelabel/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: whitelabelEBWbHVoBXUMeta?.name,
    path: "/fr/admin/whitelabel",
    component: () => import("/app/apps/valet/src/pages/admin/whitelabel.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-whitelabel___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/whitelabel/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: whitelabelEBWbHVoBXUMeta?.name,
    path: "/es/admin/whitelabel",
    component: () => import("/app/apps/valet/src/pages/admin/whitelabel.vue").then(m => m.default || m),
    children: [
  {
    name: "admin-whitelabel___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/admin/whitelabel/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "analytics-account-dashboard___en",
    path: "/analytics/account-dashboard",
    component: () => import("/app/apps/valet/src/pages/analytics/account-dashboard.vue").then(m => m.default || m)
  },
  {
    name: "analytics-account-dashboard___fr",
    path: "/fr/analytics/account-dashboard",
    component: () => import("/app/apps/valet/src/pages/analytics/account-dashboard.vue").then(m => m.default || m)
  },
  {
    name: "analytics-account-dashboard___es",
    path: "/es/analytics/account-dashboard",
    component: () => import("/app/apps/valet/src/pages/analytics/account-dashboard.vue").then(m => m.default || m)
  },
  {
    name: "analytics-api___en",
    path: "/analytics/api",
    component: () => import("/app/apps/valet/src/pages/analytics/api.vue").then(m => m.default || m)
  },
  {
    name: "analytics-api___fr",
    path: "/fr/analytics/api",
    component: () => import("/app/apps/valet/src/pages/analytics/api.vue").then(m => m.default || m)
  },
  {
    name: "analytics-api___es",
    path: "/es/analytics/api",
    component: () => import("/app/apps/valet/src/pages/analytics/api.vue").then(m => m.default || m)
  },
  {
    name: "analytics-child-account-dashboard___en",
    path: "/analytics/child-account-dashboard",
    component: () => import("/app/apps/valet/src/pages/analytics/child-account-dashboard.vue").then(m => m.default || m)
  },
  {
    name: "analytics-child-account-dashboard___fr",
    path: "/fr/analytics/child-account-dashboard",
    component: () => import("/app/apps/valet/src/pages/analytics/child-account-dashboard.vue").then(m => m.default || m)
  },
  {
    name: "analytics-child-account-dashboard___es",
    path: "/es/analytics/child-account-dashboard",
    component: () => import("/app/apps/valet/src/pages/analytics/child-account-dashboard.vue").then(m => m.default || m)
  },
  {
    name: "analytics-revenue-calculator___en",
    path: "/analytics/revenue-calculator",
    meta: revenue_45calculatorkBmbo5pLGkMeta || {},
    component: () => import("/app/apps/valet/src/pages/analytics/revenue-calculator.vue").then(m => m.default || m)
  },
  {
    name: "analytics-revenue-calculator___fr",
    path: "/fr/analytics/revenue-calculator",
    meta: revenue_45calculatorkBmbo5pLGkMeta || {},
    component: () => import("/app/apps/valet/src/pages/analytics/revenue-calculator.vue").then(m => m.default || m)
  },
  {
    name: "analytics-revenue-calculator___es",
    path: "/es/analytics/revenue-calculator",
    meta: revenue_45calculatorkBmbo5pLGkMeta || {},
    component: () => import("/app/apps/valet/src/pages/analytics/revenue-calculator.vue").then(m => m.default || m)
  },
  {
    name: claimsP2G3Mels63Meta?.name,
    path: "/claims",
    component: () => import("/app/apps/valet/src/pages/claims.vue").then(m => m.default || m),
    children: [
  {
    name: "claims-type___en",
    path: ":type()",
    component: () => import("/app/apps/valet/src/pages/claims/[type].vue").then(m => m.default || m)
  },
  {
    name: "claims___en",
    path: "",
    meta: indexHkXFeGch4QMeta || {},
    component: () => import("/app/apps/valet/src/pages/claims/index.vue").then(m => m.default || m)
  },
  {
    name: "claims-view-id___en",
    path: "view/:id()",
    component: () => import("/app/apps/valet/src/pages/claims/view/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: claimsP2G3Mels63Meta?.name,
    path: "/fr/claims",
    component: () => import("/app/apps/valet/src/pages/claims.vue").then(m => m.default || m),
    children: [
  {
    name: "claims-type___fr",
    path: ":type()",
    component: () => import("/app/apps/valet/src/pages/claims/[type].vue").then(m => m.default || m)
  },
  {
    name: "claims___fr",
    path: "",
    meta: indexHkXFeGch4QMeta || {},
    component: () => import("/app/apps/valet/src/pages/claims/index.vue").then(m => m.default || m)
  },
  {
    name: "claims-view-id___fr",
    path: "view/:id()",
    component: () => import("/app/apps/valet/src/pages/claims/view/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: claimsP2G3Mels63Meta?.name,
    path: "/es/claims",
    component: () => import("/app/apps/valet/src/pages/claims.vue").then(m => m.default || m),
    children: [
  {
    name: "claims-type___es",
    path: ":type()",
    component: () => import("/app/apps/valet/src/pages/claims/[type].vue").then(m => m.default || m)
  },
  {
    name: "claims___es",
    path: "",
    meta: indexHkXFeGch4QMeta || {},
    component: () => import("/app/apps/valet/src/pages/claims/index.vue").then(m => m.default || m)
  },
  {
    name: "claims-view-id___es",
    path: "view/:id()",
    component: () => import("/app/apps/valet/src/pages/claims/view/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "customers-customerId___en",
    path: "/customers/:customerId()",
    component: () => import("/app/apps/valet/src/pages/customers/[customerId].vue").then(m => m.default || m)
  },
  {
    name: "customers-customerId___fr",
    path: "/fr/customers/:customerId()",
    component: () => import("/app/apps/valet/src/pages/customers/[customerId].vue").then(m => m.default || m)
  },
  {
    name: "customers-customerId___es",
    path: "/es/customers/:customerId()",
    component: () => import("/app/apps/valet/src/pages/customers/[customerId].vue").then(m => m.default || m)
  },
  {
    name: "customers___en",
    path: "/customers",
    component: () => import("/app/apps/valet/src/pages/customers/index.vue").then(m => m.default || m)
  },
  {
    name: "customers___fr",
    path: "/fr/customers",
    component: () => import("/app/apps/valet/src/pages/customers/index.vue").then(m => m.default || m)
  },
  {
    name: "customers___es",
    path: "/es/customers",
    component: () => import("/app/apps/valet/src/pages/customers/index.vue").then(m => m.default || m)
  },
  {
    name: dashboardLo4QSk7jTkMeta?.name,
    path: "/dashboard",
    component: () => import("/app/apps/valet/src/pages/dashboard.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard___en",
    path: "",
    meta: indexM07iimR40CMeta || {},
    component: () => import("/app/apps/valet/src/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-overview___en",
    path: "overview",
    component: () => import("/app/apps/valet/src/pages/dashboard/overview.vue").then(m => m.default || m)
  }
]
  },
  {
    name: dashboardLo4QSk7jTkMeta?.name,
    path: "/fr/dashboard",
    component: () => import("/app/apps/valet/src/pages/dashboard.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard___fr",
    path: "",
    meta: indexM07iimR40CMeta || {},
    component: () => import("/app/apps/valet/src/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-overview___fr",
    path: "overview",
    component: () => import("/app/apps/valet/src/pages/dashboard/overview.vue").then(m => m.default || m)
  }
]
  },
  {
    name: dashboardLo4QSk7jTkMeta?.name,
    path: "/es/dashboard",
    component: () => import("/app/apps/valet/src/pages/dashboard.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard___es",
    path: "",
    meta: indexM07iimR40CMeta || {},
    component: () => import("/app/apps/valet/src/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-overview___es",
    path: "overview",
    component: () => import("/app/apps/valet/src/pages/dashboard/overview.vue").then(m => m.default || m)
  }
]
  },
  {
    name: developerHdYkS8ExoqMeta?.name,
    path: "/developer",
    meta: developerHdYkS8ExoqMeta || {},
    component: () => import("/app/apps/valet/src/pages/developer.vue").then(m => m.default || m),
    children: [
  {
    name: _91appId_93NR2akGmVH4Meta?.name,
    path: "apps/:appId()",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId].vue").then(m => m.default || m),
    children: [
  {
    name: "developer-apps-appId-edit___en",
    path: "edit",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/edit.vue").then(m => m.default || m)
  },
  {
    name: "developer-apps-appId___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/index.vue").then(m => m.default || m)
  },
  {
    name: "developer-apps-appId-installations___en",
    path: "installations",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/installations.vue").then(m => m.default || m)
  },
  {
    name: "developer-apps-appId-submission___en",
    path: "submission",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/submission.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "developer-apps___en",
    path: "apps",
    component: () => import("/app/apps/valet/src/pages/developer/apps/index.vue").then(m => m.default || m)
  },
  {
    name: "developer-collaborations___en",
    path: "collaborations",
    component: () => import("/app/apps/valet/src/pages/developer/collaborations/index.vue").then(m => m.default || m)
  },
  {
    name: "developer___en",
    path: "",
    meta: index8dVnShfs5SMeta || {},
    component: () => import("/app/apps/valet/src/pages/developer/index.vue").then(m => m.default || m)
  },
  {
    name: "developer-organization___en",
    path: "organization",
    component: () => import("/app/apps/valet/src/pages/developer/organization.vue").then(m => m.default || m)
  },
  {
    name: "developer-signup___en",
    path: "signup",
    meta: signupsxCZR4XNbNMeta || {},
    component: () => import("/app/apps/valet/src/pages/developer/signup.vue").then(m => m.default || m)
  }
]
  },
  {
    name: developerHdYkS8ExoqMeta?.name,
    path: "/fr/developer",
    meta: developerHdYkS8ExoqMeta || {},
    component: () => import("/app/apps/valet/src/pages/developer.vue").then(m => m.default || m),
    children: [
  {
    name: _91appId_93NR2akGmVH4Meta?.name,
    path: "apps/:appId()",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId].vue").then(m => m.default || m),
    children: [
  {
    name: "developer-apps-appId-edit___fr",
    path: "edit",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/edit.vue").then(m => m.default || m)
  },
  {
    name: "developer-apps-appId___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/index.vue").then(m => m.default || m)
  },
  {
    name: "developer-apps-appId-installations___fr",
    path: "installations",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/installations.vue").then(m => m.default || m)
  },
  {
    name: "developer-apps-appId-submission___fr",
    path: "submission",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/submission.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "developer-apps___fr",
    path: "apps",
    component: () => import("/app/apps/valet/src/pages/developer/apps/index.vue").then(m => m.default || m)
  },
  {
    name: "developer-collaborations___fr",
    path: "collaborations",
    component: () => import("/app/apps/valet/src/pages/developer/collaborations/index.vue").then(m => m.default || m)
  },
  {
    name: "developer___fr",
    path: "",
    meta: index8dVnShfs5SMeta || {},
    component: () => import("/app/apps/valet/src/pages/developer/index.vue").then(m => m.default || m)
  },
  {
    name: "developer-organization___fr",
    path: "organization",
    component: () => import("/app/apps/valet/src/pages/developer/organization.vue").then(m => m.default || m)
  },
  {
    name: "developer-signup___fr",
    path: "signup",
    meta: signupsxCZR4XNbNMeta || {},
    component: () => import("/app/apps/valet/src/pages/developer/signup.vue").then(m => m.default || m)
  }
]
  },
  {
    name: developerHdYkS8ExoqMeta?.name,
    path: "/es/developer",
    meta: developerHdYkS8ExoqMeta || {},
    component: () => import("/app/apps/valet/src/pages/developer.vue").then(m => m.default || m),
    children: [
  {
    name: _91appId_93NR2akGmVH4Meta?.name,
    path: "apps/:appId()",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId].vue").then(m => m.default || m),
    children: [
  {
    name: "developer-apps-appId-edit___es",
    path: "edit",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/edit.vue").then(m => m.default || m)
  },
  {
    name: "developer-apps-appId___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/index.vue").then(m => m.default || m)
  },
  {
    name: "developer-apps-appId-installations___es",
    path: "installations",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/installations.vue").then(m => m.default || m)
  },
  {
    name: "developer-apps-appId-submission___es",
    path: "submission",
    component: () => import("/app/apps/valet/src/pages/developer/apps/[appId]/submission.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "developer-apps___es",
    path: "apps",
    component: () => import("/app/apps/valet/src/pages/developer/apps/index.vue").then(m => m.default || m)
  },
  {
    name: "developer-collaborations___es",
    path: "collaborations",
    component: () => import("/app/apps/valet/src/pages/developer/collaborations/index.vue").then(m => m.default || m)
  },
  {
    name: "developer___es",
    path: "",
    meta: index8dVnShfs5SMeta || {},
    component: () => import("/app/apps/valet/src/pages/developer/index.vue").then(m => m.default || m)
  },
  {
    name: "developer-organization___es",
    path: "organization",
    component: () => import("/app/apps/valet/src/pages/developer/organization.vue").then(m => m.default || m)
  },
  {
    name: "developer-signup___es",
    path: "signup",
    meta: signupsxCZR4XNbNMeta || {},
    component: () => import("/app/apps/valet/src/pages/developer/signup.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "gallery-type___en",
    path: "/gallery/:type()",
    component: () => import("/app/apps/valet/src/pages/gallery/[type].vue").then(m => m.default || m)
  },
  {
    name: "gallery-type___fr",
    path: "/fr/gallery/:type()",
    component: () => import("/app/apps/valet/src/pages/gallery/[type].vue").then(m => m.default || m)
  },
  {
    name: "gallery-type___es",
    path: "/es/gallery/:type()",
    component: () => import("/app/apps/valet/src/pages/gallery/[type].vue").then(m => m.default || m)
  },
  {
    name: "gallery___en",
    path: "/gallery",
    meta: index9b1wYVE4IJMeta || {},
    component: () => import("/app/apps/valet/src/pages/gallery/index.vue").then(m => m.default || m)
  },
  {
    name: "gallery___fr",
    path: "/fr/gallery",
    meta: index9b1wYVE4IJMeta || {},
    component: () => import("/app/apps/valet/src/pages/gallery/index.vue").then(m => m.default || m)
  },
  {
    name: "gallery___es",
    path: "/es/gallery",
    meta: index9b1wYVE4IJMeta || {},
    component: () => import("/app/apps/valet/src/pages/gallery/index.vue").then(m => m.default || m)
  },
  {
    name: "hidden-by-account-admin___en",
    path: "/hidden-by-account-admin",
    component: () => import("/app/apps/valet/src/pages/hidden-by-account-admin.vue").then(m => m.default || m)
  },
  {
    name: "hidden-by-account-admin___fr",
    path: "/fr/hidden-by-account-admin",
    component: () => import("/app/apps/valet/src/pages/hidden-by-account-admin.vue").then(m => m.default || m)
  },
  {
    name: "hidden-by-account-admin___es",
    path: "/es/hidden-by-account-admin",
    component: () => import("/app/apps/valet/src/pages/hidden-by-account-admin.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/apps/valet/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/apps/valet/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/apps/valet/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "integrations___en",
    path: "/integrations",
    component: () => import("/app/apps/valet/src/pages/integrations.vue").then(m => m.default || m),
    children: [
  {
    name: "integrations-active___en",
    path: "active",
    component: () => import("/app/apps/valet/src/pages/integrations/active.vue").then(m => m.default || m)
  },
  {
    name: "integrations-available___en",
    path: "available",
    component: () => import("/app/apps/valet/src/pages/integrations/available.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "integrations___fr",
    path: "/fr/integrations",
    component: () => import("/app/apps/valet/src/pages/integrations.vue").then(m => m.default || m),
    children: [
  {
    name: "integrations-active___fr",
    path: "active",
    component: () => import("/app/apps/valet/src/pages/integrations/active.vue").then(m => m.default || m)
  },
  {
    name: "integrations-available___fr",
    path: "available",
    component: () => import("/app/apps/valet/src/pages/integrations/available.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "integrations___es",
    path: "/es/integrations",
    component: () => import("/app/apps/valet/src/pages/integrations.vue").then(m => m.default || m),
    children: [
  {
    name: "integrations-active___es",
    path: "active",
    component: () => import("/app/apps/valet/src/pages/integrations/active.vue").then(m => m.default || m)
  },
  {
    name: "integrations-available___es",
    path: "available",
    component: () => import("/app/apps/valet/src/pages/integrations/available.vue").then(m => m.default || m)
  }
]
  },
  {
    name: loginXuUDFXbT8eMeta?.name,
    path: "/login",
    component: () => import("/app/apps/valet/src/pages/login.vue").then(m => m.default || m),
    children: [
  {
    name: "login-callback___en",
    path: "callback",
    component: () => import("/app/apps/valet/src/pages/login/callback.vue").then(m => m.default || m)
  },
  {
    name: "login___en",
    path: "",
    meta: indexzxcf67RnbkMeta || {},
    component: () => import("/app/apps/valet/src/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: "login-mfa-email___en",
    path: "mfa/email",
    component: () => import("/app/apps/valet/src/pages/login/mfa/email.vue").then(m => m.default || m)
  },
  {
    name: "login-mfa___en",
    path: "mfa",
    component: () => import("/app/apps/valet/src/pages/login/mfa/index.vue").then(m => m.default || m)
  },
  {
    name: "login-mfa-otp___en",
    path: "mfa/otp",
    component: () => import("/app/apps/valet/src/pages/login/mfa/otp.vue").then(m => m.default || m)
  },
  {
    name: "login-not-found___en",
    path: "not-found",
    component: () => import("/app/apps/valet/src/pages/login/not-found.vue").then(m => m.default || m)
  },
  {
    name: "login-reset___en",
    path: "reset",
    component: () => import("/app/apps/valet/src/pages/login/reset.vue").then(m => m.default || m)
  },
  {
    name: "login-set-password___en",
    path: "set-password",
    component: () => import("/app/apps/valet/src/pages/login/set-password.vue").then(m => m.default || m)
  },
  {
    name: "login-welcome___en",
    path: "welcome",
    meta: welcomexUye6lIWzWMeta || {},
    component: () => import("/app/apps/valet/src/pages/login/welcome.vue").then(m => m.default || m)
  }
]
  },
  {
    name: loginXuUDFXbT8eMeta?.name,
    path: "/fr/login",
    component: () => import("/app/apps/valet/src/pages/login.vue").then(m => m.default || m),
    children: [
  {
    name: "login-callback___fr",
    path: "callback",
    component: () => import("/app/apps/valet/src/pages/login/callback.vue").then(m => m.default || m)
  },
  {
    name: "login___fr",
    path: "",
    meta: indexzxcf67RnbkMeta || {},
    component: () => import("/app/apps/valet/src/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: "login-mfa-email___fr",
    path: "mfa/email",
    component: () => import("/app/apps/valet/src/pages/login/mfa/email.vue").then(m => m.default || m)
  },
  {
    name: "login-mfa___fr",
    path: "mfa",
    component: () => import("/app/apps/valet/src/pages/login/mfa/index.vue").then(m => m.default || m)
  },
  {
    name: "login-mfa-otp___fr",
    path: "mfa/otp",
    component: () => import("/app/apps/valet/src/pages/login/mfa/otp.vue").then(m => m.default || m)
  },
  {
    name: "login-not-found___fr",
    path: "not-found",
    component: () => import("/app/apps/valet/src/pages/login/not-found.vue").then(m => m.default || m)
  },
  {
    name: "login-reset___fr",
    path: "reset",
    component: () => import("/app/apps/valet/src/pages/login/reset.vue").then(m => m.default || m)
  },
  {
    name: "login-set-password___fr",
    path: "set-password",
    component: () => import("/app/apps/valet/src/pages/login/set-password.vue").then(m => m.default || m)
  },
  {
    name: "login-welcome___fr",
    path: "welcome",
    meta: welcomexUye6lIWzWMeta || {},
    component: () => import("/app/apps/valet/src/pages/login/welcome.vue").then(m => m.default || m)
  }
]
  },
  {
    name: loginXuUDFXbT8eMeta?.name,
    path: "/es/login",
    component: () => import("/app/apps/valet/src/pages/login.vue").then(m => m.default || m),
    children: [
  {
    name: "login-callback___es",
    path: "callback",
    component: () => import("/app/apps/valet/src/pages/login/callback.vue").then(m => m.default || m)
  },
  {
    name: "login___es",
    path: "",
    meta: indexzxcf67RnbkMeta || {},
    component: () => import("/app/apps/valet/src/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: "login-mfa-email___es",
    path: "mfa/email",
    component: () => import("/app/apps/valet/src/pages/login/mfa/email.vue").then(m => m.default || m)
  },
  {
    name: "login-mfa___es",
    path: "mfa",
    component: () => import("/app/apps/valet/src/pages/login/mfa/index.vue").then(m => m.default || m)
  },
  {
    name: "login-mfa-otp___es",
    path: "mfa/otp",
    component: () => import("/app/apps/valet/src/pages/login/mfa/otp.vue").then(m => m.default || m)
  },
  {
    name: "login-not-found___es",
    path: "not-found",
    component: () => import("/app/apps/valet/src/pages/login/not-found.vue").then(m => m.default || m)
  },
  {
    name: "login-reset___es",
    path: "reset",
    component: () => import("/app/apps/valet/src/pages/login/reset.vue").then(m => m.default || m)
  },
  {
    name: "login-set-password___es",
    path: "set-password",
    component: () => import("/app/apps/valet/src/pages/login/set-password.vue").then(m => m.default || m)
  },
  {
    name: "login-welcome___es",
    path: "welcome",
    meta: welcomexUye6lIWzWMeta || {},
    component: () => import("/app/apps/valet/src/pages/login/welcome.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "orders___en",
    path: "/orders",
    component: () => import("/app/apps/valet/src/pages/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "orders___fr",
    path: "/fr/orders",
    component: () => import("/app/apps/valet/src/pages/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "orders___es",
    path: "/es/orders",
    component: () => import("/app/apps/valet/src/pages/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "personal-access-tokens___en",
    path: "/personal-access-tokens",
    component: () => import("/app/apps/valet/src/pages/personal-access-tokens.vue").then(m => m.default || m)
  },
  {
    name: "personal-access-tokens___fr",
    path: "/fr/personal-access-tokens",
    component: () => import("/app/apps/valet/src/pages/personal-access-tokens.vue").then(m => m.default || m)
  },
  {
    name: "personal-access-tokens___es",
    path: "/es/personal-access-tokens",
    component: () => import("/app/apps/valet/src/pages/personal-access-tokens.vue").then(m => m.default || m)
  },
  {
    name: "products___en",
    path: "/products",
    component: () => import("/app/apps/valet/src/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: "products___fr",
    path: "/fr/products",
    component: () => import("/app/apps/valet/src/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: "products___es",
    path: "/es/products",
    component: () => import("/app/apps/valet/src/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: returnsHDhAWHctVlMeta?.name,
    path: "/returns",
    component: () => import("/app/apps/valet/src/pages/returns.vue").then(m => m.default || m),
    children: [
  {
    name: "returns___en",
    path: "",
    component: () => import("/app/apps/valet/src/pages/returns/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: returnsHDhAWHctVlMeta?.name,
    path: "/fr/returns",
    component: () => import("/app/apps/valet/src/pages/returns.vue").then(m => m.default || m),
    children: [
  {
    name: "returns___fr",
    path: "",
    component: () => import("/app/apps/valet/src/pages/returns/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: returnsHDhAWHctVlMeta?.name,
    path: "/es/returns",
    component: () => import("/app/apps/valet/src/pages/returns.vue").then(m => m.default || m),
    children: [
  {
    name: "returns___es",
    path: "",
    component: () => import("/app/apps/valet/src/pages/returns/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "reviews___en",
    path: "/reviews",
    component: () => import("/app/apps/valet/src/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: "reviews___fr",
    path: "/fr/reviews",
    component: () => import("/app/apps/valet/src/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: "reviews___es",
    path: "/es/reviews",
    component: () => import("/app/apps/valet/src/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: store_45creditMDe6yHOjqUMeta?.name,
    path: "/store-credit",
    component: () => import("/app/apps/valet/src/pages/store-credit.vue").then(m => m.default || m),
    children: [
  {
    name: "store-credit-type___en",
    path: ":type()",
    component: () => import("/app/apps/valet/src/pages/store-credit/[type].vue").then(m => m.default || m)
  },
  {
    name: "store-credit___en",
    path: "",
    meta: index4PvaHPyIn9Meta || {},
    component: () => import("/app/apps/valet/src/pages/store-credit/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: store_45creditMDe6yHOjqUMeta?.name,
    path: "/fr/store-credit",
    component: () => import("/app/apps/valet/src/pages/store-credit.vue").then(m => m.default || m),
    children: [
  {
    name: "store-credit-type___fr",
    path: ":type()",
    component: () => import("/app/apps/valet/src/pages/store-credit/[type].vue").then(m => m.default || m)
  },
  {
    name: "store-credit___fr",
    path: "",
    meta: index4PvaHPyIn9Meta || {},
    component: () => import("/app/apps/valet/src/pages/store-credit/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: store_45creditMDe6yHOjqUMeta?.name,
    path: "/es/store-credit",
    component: () => import("/app/apps/valet/src/pages/store-credit.vue").then(m => m.default || m),
    children: [
  {
    name: "store-credit-type___es",
    path: ":type()",
    component: () => import("/app/apps/valet/src/pages/store-credit/[type].vue").then(m => m.default || m)
  },
  {
    name: "store-credit___es",
    path: "",
    meta: index4PvaHPyIn9Meta || {},
    component: () => import("/app/apps/valet/src/pages/store-credit/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "store-reinstall-complete___en",
    path: "/store/reinstall-complete",
    meta: reinstall_45complete1cMWZGjIi2Meta || {},
    component: () => import("/app/apps/valet/src/pages/store/reinstall-complete.vue").then(m => m.default || m)
  },
  {
    name: "store-reinstall-complete___fr",
    path: "/fr/store/reinstall-complete",
    meta: reinstall_45complete1cMWZGjIi2Meta || {},
    component: () => import("/app/apps/valet/src/pages/store/reinstall-complete.vue").then(m => m.default || m)
  },
  {
    name: "store-reinstall-complete___es",
    path: "/es/store/reinstall-complete",
    meta: reinstall_45complete1cMWZGjIi2Meta || {},
    component: () => import("/app/apps/valet/src/pages/store/reinstall-complete.vue").then(m => m.default || m)
  },
  {
    name: "store-reinstall___en",
    path: "/store/reinstall",
    component: () => import("/app/apps/valet/src/pages/store/reinstall.vue").then(m => m.default || m)
  },
  {
    name: "store-reinstall___fr",
    path: "/fr/store/reinstall",
    component: () => import("/app/apps/valet/src/pages/store/reinstall.vue").then(m => m.default || m)
  },
  {
    name: "store-reinstall___es",
    path: "/es/store/reinstall",
    component: () => import("/app/apps/valet/src/pages/store/reinstall.vue").then(m => m.default || m)
  },
  {
    name: "unauthorized___en",
    path: "/unauthorized",
    component: () => import("/app/apps/valet/src/pages/unauthorized.vue").then(m => m.default || m)
  },
  {
    name: "unauthorized___fr",
    path: "/fr/unauthorized",
    component: () => import("/app/apps/valet/src/pages/unauthorized.vue").then(m => m.default || m)
  },
  {
    name: "unauthorized___es",
    path: "/es/unauthorized",
    component: () => import("/app/apps/valet/src/pages/unauthorized.vue").then(m => m.default || m)
  },
  {
    name: "warranties-type___en",
    path: "/warranties/:type()",
    component: () => import("/app/apps/valet/src/pages/warranties/[type].vue").then(m => m.default || m)
  },
  {
    name: "warranties-type___fr",
    path: "/fr/warranties/:type()",
    component: () => import("/app/apps/valet/src/pages/warranties/[type].vue").then(m => m.default || m)
  },
  {
    name: "warranties-type___es",
    path: "/es/warranties/:type()",
    component: () => import("/app/apps/valet/src/pages/warranties/[type].vue").then(m => m.default || m)
  },
  {
    name: "warranties___en",
    path: "/warranties",
    meta: indexgJkUrSXUweMeta || {},
    component: () => import("/app/apps/valet/src/pages/warranties/index.vue").then(m => m.default || m)
  },
  {
    name: "warranties___fr",
    path: "/fr/warranties",
    meta: indexgJkUrSXUweMeta || {},
    component: () => import("/app/apps/valet/src/pages/warranties/index.vue").then(m => m.default || m)
  },
  {
    name: "warranties___es",
    path: "/es/warranties",
    meta: indexgJkUrSXUweMeta || {},
    component: () => import("/app/apps/valet/src/pages/warranties/index.vue").then(m => m.default || m)
  }
]